import React from 'react';

import modal from './modal';

import { ModalFooter } from 'reactstrap';

function confirm(conf) {
	modal({
		id: conf.id,
		header: conf.header,
		body: (
			<div>
				<div className='pb-1'>{conf.message}</div>
				<ModalFooter>
					<button
						type='button'
						className='btn btn-default float-left'
						onClick={modal.close.bind(this, conf.id)}
					>
						Cancel
					</button>
					<button
						className='btn btn-primary'
						onClick={confirmFunc.bind(this, conf)}
					>
						{conf.confirmButtonText}
					</button>
				</ModalFooter>
			</div>
		),
		close: false,
		noFooter: true,
	});
}

function confirmFunc(conf) {
	modal.close(conf.id);

	if (conf.confirmFunc) {
		conf.confirmFunc();
	}
}

confirm.close = (i) => {
	modal.close(i);
};

export default confirm;
